// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YvUyNRCKIccnCaDrCiqi{max-width:432px}.Ge1XJ1ZOfl48JagcfT9s{max-width:100%;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamsSelectPlaceholder": `YvUyNRCKIccnCaDrCiqi`,
	"teamChip": `Ge1XJ1ZOfl48JagcfT9s`
};
export default ___CSS_LOADER_EXPORT___;
